import { takeEvery, call, put, all, fork, select } from 'redux-saga/effects';
import { FETCH_TASKS, PUT_TASKS, actionCreators } from './action';

import { actionCreators as actionCreatorsSpinner } from '../Spinner/action';

import { reduxSagaFirebase } from '../../rootFirebase';
import {user} from '../../selectors/user';
import firebase from 'firebase';
// export function* onFetchExpenseSaga() {
// 	const userId = yield select(user);
// 	const snapshot = yield call(reduxSagaFirebase.database.read, userId+'/expenses');

// 	yield put(actionCreators.putExpenses(table));
// 	yield put(actionCreators.putHistoryExpenses(multiHistoryExpenses));
// }

// export function* fetchExpenes() {
// 	yield takeEvery(FETCH_EXPENSES, onFetchExpenseSaga);
// }

export function* onFetchTasksSaga(action) {

	const userId = yield select(user);
	yield put(actionCreatorsSpinner.showSpinner());
    const data = yield call(
		reduxSagaFirebase.database.read, 
		`/tasks/${userId}/`
		//firebase.database().reference(`tasks`)
		);

		
	yield put(actionCreators.putTasks(data));
	yield put(actionCreatorsSpinner.hideSpinner());
}

export function* fetchTasks() {
	yield takeEvery(FETCH_TASKS, onFetchTasksSaga);
}

export function* expensesSaga() {
	yield all([fork(fetchTasks)]);
}
